import { PENDING_CASE_SUCCESS ,FORMER_VALIDATE_SECURE_PIN_SUCCESS} from "../actions/types";
import { VALIDATE_SECURE_PIN_SUCCESS } from "../../DownloadAndDelete/actions/types";

const initialState = {
  firstName: "",
  lastName: "",
  status: "",
  formerId: "",
  accountInfo: [],
  caseId:"",
  isCasePending:"",
  byPassEmail:""
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case PENDING_CASE_SUCCESS:
      return {
        ...state,
        ...payload
      };
    case FORMER_VALIDATE_SECURE_PIN_SUCCESS:
      return {
        ...state,
        ...payload
      };
    case VALIDATE_SECURE_PIN_SUCCESS:               //CXTDT-665511 developer Arvind
      return {
        ...state,
        ...payload
      };
    default:
      return state;
  }
};
